import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import PrimeVue from 'primevue/config'

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'

import 'bootstrap/dist/css/bootstrap.css'

import 'primevue/resources/themes/bootstrap4-light-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

const app = createApp(App)

app.config.devtools = true

app.use(store)
app.use(router)
// app.use(PrimeVue)

app.component('DataTable', DataTable)
app.component('TableColumn', Column)
app.component('InputText', InputText)
app.component('PVButton', Button)
app.component('PVDropdown', Dropdown)

app.mount('#app')
